@if (langList.length > 1) {
  <div class="lang-selector-wrapper">
    @if (flatMode) {
      <ul role="listbox" [attr.aria-label]="'Language Selector'|translate" class="lang-menu d-flex list-unstyled">
        @for (lang of langList; track lang; let last = $last) {
          <li class="lang-item" [class.current]="isCurrentLang(lang)">
            <button role="option"
              lang="{{lang?.code}}"
              (click)="langSvc.langSelected(lang)"
              [class]="lang?.flag+'-flag'">
              {{lang?.name}}
            </button>
          </li>
          @if (!last) {
            <li class="divider" aria-hidden="true">
              <ng-content select=".lang-selector-divider"></ng-content>
            </li>
          }
        }
      </ul>
    } @else {
      <button mat-button [matMenuTriggerFor]="menu"
        aria-haspopup="menu"
        [class]="dropdownBtnClass"
        [attr.aria-label]="'Language Selector'|translate">
        <ng-content select=".lang-selector-trigger-prefix"></ng-content>
        <span class="titleLang" translate>{{ langSvc.currLangName ? langSvc.currLangName : 'Languages'}}</span>
        <ng-content select=".lang-selector-trigger-suffix"></ng-content>
        @if (showFlagIcon) {
          <span class="fi fi-{{langSvc?.CurrLang?.flag}} iconLang"
            lang="{{langSvc?.CurrLang?.code}}">
          </span>
        }
      </button>
      <mat-menu #menu="matMenu" class="lang-menu" role="navigation" [attr.aria-label]="'Language Selector Navigation'|translate">
        @for (lang of langList; track lang) {
          <button mat-menu-item
            lang="{{lang?.code}}"
            [class]="lang?.flag+'-flag'"
            [class.current]="isCurrentLang(lang)"
            (click)="langSvc.langSelected(lang)"
            [title]="('langMenu-'+lang?.origin)|translate">
            {{lang?.name}}
          </button>
        }
      </mat-menu>
    }
  </div>
}
